<template lang="html">
  <v-toolbar flat color="blue" dense dark>
    <share-link-button/>
    <v-spacer></v-spacer>
    <v-btn text @click="goBackToHomePage()">Posdata Transactions</v-btn>
    <v-spacer></v-spacer>
      <v-btn small text>
        <v-icon small class="mr-1">mdi-account</v-icon>
        {{userName}}
      </v-btn>
  </v-toolbar>
</template>

<script>
  import ShareLinkButton from "@/components/home/ShareLinkButton";
  import {USER_NS} from "@/store/modules/user/constants";
  import {mapGetters} from "vuex";
  import Swal from 'sweetalert2';

  export default {
    components: {ShareLinkButton},
    computed: {
      ...mapGetters(USER_NS, ['userName'])
    },
    beforeMount: function () {
      if (localStorage.getItem("was_warned") !== "true") {
        if (this.isEuropePPEnvironment()) {

          Swal.fire({
            title: 'Warning: URL change',
            html: 'Since the 31/03/2023, <b> Posdata dashboard </b> isn\'t accessible from this url OUTSIDE of Decathlon Network.<br>' +
                'For <b>Decathlon network</b> the url is still : <a href="https://dashboard.posdata-qualification.decathlon.io">https://dashboard.posdata-qualification.decathlon.io</a><br>' +
                '<b>Outside of Decathlon network</b> the url is now : <a href="https://dashboard.posdata-qualification.decathlon.net">https://dashboard.posdata-qualification.decathlon.net</a>',
            icon: 'warning',
            confirmButtonText: 'I\'ve seen the url change and taken it into account'
          })

        } else if (this.isEuropeProdEnvironment()){

          Swal.fire({
            title: 'Warning: URL change',
            html: 'Since the 31/03/2023, <b> Posdata dashboard </b> isn\'t accessible from this url OUTSIDE of Decathlon Network.<br>' +
                'For <b>Decathlon network</b> the url is still : <a href="https://dashboard.posdata.decathlon.io">https://dashboard.posdata.decathlon.io</a><br>' +
                '<b>Outside of Decathlon network</b> the url is now : <a href="https://dashboard.posdata.decathlon.net">https://dashboard.posdata.decathlon.net</a>',
            icon: 'warning',
            confirmButtonText: 'I\'ve seen the url change and taken it into account'
          })
        }
        localStorage.setItem("was_warned", "true");
      }
    },
    methods: {
      goBackToHomePage() {
        this.$router.push({name: 'home', params: {}})
      },
      isEuropePPEnvironment() {
        return !!window.location.host.includes("posdata-qualification.decathlon");
      },
      isEuropeProdEnvironment() {
        return !!window.location.host.includes("posdata.decathlon");
      }
    }
  }
</script>

<style lang="css" scoped>
.clickable {
  cursor: pointer;
}
</style>
